export default {
    "msg": {
        "8": "8",
        "20": "20",
        "250": "250",
        "Enter a new password": "Saisissez un nouveau mot de passe",
        "Empty": "空",
        "No data": "Aucune donnée",
        //"Installation Package List": "Liste de packages d’installation",
        "Update Package": "Package de mise à jour",
     
        "Settings - Profiles": "Paramètres - Profils",
        "User Management": "Gestion des utilisateurs",
        "Operation Records": "Enregistrement des opérations",
        "Exit": "Quitter",
        "Total pages:": "Nombre total de pages:",
        "page": "page",
        "Go to": "Aller à ",
        "Prev": "Préc.",
        "Next": "Suivant",
        "per page": "Chaque page",
        "items": "Article",
        "Please enter the page number to go to": "Veuillez entrer aller au nombre de pages",
        "Language": "Langue",
        "Profile Picture": "Photo de profil",
        "Old Password": "Ancien mot de passe",
        "New Password": "Nouveau mot de passe",
        "Confirm Password": "Confirmer le mot de passe",
        "The two passwords entered do not match": "Les deux mots de passe saisis ne correspondent pas",
        "Enter the new password again": "Saisissez à nouveau le nouveau mot de passe.",
        "This must match the new password above": "Celui-ci doit être identique au nouveau mot de passe ci-dessus.",
        "Invalid input。Password length must be 8–16 characters": "Entrée non valide. Le mot de passe doit comporter entre 8 et 16 caractères",
        "Lenovo Privacy Statement": "la Déclaration de confidentialité de Lenovo",
        "Lenovo Software License Agreement": "Contrat de licence du logiciel Lenovo",
        "Third-Party Notice": "Notification de tiers",
        "Third-party notifications":"Notifications de tiers",
        "Change Password": "Modifier le mot de passe",
        "Edit Profile": "Modifier le profil",
        "Exited successfully": "Sortie réussie",
        "Admin": "Admin",
        "Common user": "Utilisateur standard",
        "Super Admin":"Super Administrateur",
        "Model": "Modèle",
        "Are you sure you want to delete this?": "Voulez-vous vraiment supprimer ?",
        "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters": "Saisissez un nouveau mot de passe.Il doit comprendre au moins trois des éléments suivants : lettres majuscules, lettres minuscules, chiffres et caractères spéciaux.",
        "It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters": "Il doit comprendre au moins trois des éléments suivants : lettres majuscules, lettres minuscules, chiffres et caractères spéciaux.",
        "Tip": "Conseil",
        "Confirm": "Confirmer",
        "Cancel": "Annuler",
        "Deletion successful": "Suppression réussie",
        "Password changed successfully": "Mot de passe modifié",
        "The file to upload is larger than 100 MB。 Please select another one。": "La taille du fichier à charger est supérieure à 100 Mo. Sélectionnez-en un autre.",
        "Your session has expired。 Please log in again。": "Le statut de connexion actuel a expiré, veuillez vous reconnecter!",
        "Invalid network request URL": "L'adresse de la demande réseau est incorrecte!",
        "Unknown server error": "Une erreur inconnue est survenue sur le serveur!",
        "An unknown error has occurred": "Une erreur inconnue s'est produite!",
        "Request timeout Please check your network and try again": "Délai de la demande expiré. Vérifiez votre réseau et réessayez.",
        "Failed to connect to server": "Échec de la connexion au serveur",
        "Your network may be currently disconnected": "Votre réseau est peut-être actuellement déconnecté",
        "No related device found": "Aucun équipement connexe trouvé",
        "Pre-upgrade component not found in the device": "Composant de pré - mise à niveau non trouvé dans l'appareil",
        "FWID of the installation component not found": "Composants d'installation fwid introuvable",
        "Failed to set upgrade information": "Échec de la configuration des informations de mise à niveau",
        "Failed to set specified update options": "Spécifier l'échec des paramètres de mise à jour",
        "Failed to install the update package": "L'installation du package de mise à jour a échoué",
        "Failed to obtain the device handle": "L'acquisition du Handle du périphérique a échoué",
        "Upgrade device mismatch": "Mise à niveau des appareils ne correspondent pas",
        "Installation failed: Pre-upgrade component not found in the device": "Impossible d'installer: aucun composant de pré - mise à niveau n'a été trouvé dans l'appareil",
        "Installation failed: FWID mismatch in the component list": "Impossible d'installer: fwid ne correspond pas dans le composant",
        "Installation failed: No matching monitor found for upgrade": "Impossible d'installer: aucun moniteur correspondant à la mise à niveau n'a été trouvé",
        "The monitor does not exist": "Le moniteur n’existe pas",
        "The command has been sent": "La commande a été envoyée",
        "The group does not exist": "Le groupe n’existe pas",
        "The command does not exist": "La commande n’existe pas",
        "Setting does not exist": "Les paramètres n'existent pas",
        "The settings profile does not exist": "Le profil de paramètres n’existe pas",
        "The update package does not exist": "Le package de mise à jour n’existe pas",
        "The update package record does not exist": "L'enregistrement du package de mise à jour n’existe pas",
        "Invalid password format。 It must be between 8 and 30 characters long。": "Format de mot de passe non valide. Il doit comporter entre 8 et 30 caractères.",
        "Password format is incorrect, password must include at least three types of the following: uppercase letters, lowercase letters, digits, and special characters": "密码格式不正确，密码至少包含大写字母、小写字母、数字和特殊字符中的三种类型",
        "The field is empty": "Le champ est vide",
        "Update time cannot be null": "Le temps de mise à niveau ne peut pas être vide",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。": "Heure de mise à jour incorrecte. Elle ne peut pas être antérieure à l’heure actuelle ou à plus de 30 jours dans le futur.",
        "Uploaded file is null": "Le fichier téléchargé est vide",
        "Uploaded file format is incorrect， file format can only be zip/exe/dmg/app": "上传文件格式不正确,文件格式只能为zip/exe/dmg/app",
        "Uploaded file format is incorrect， file cannot have no extension": "上传文件格式不正确,文件不能没有后缀",
        "Login failed。 Make sure you entered the correct account ID and password。": "Échec de la connexion. Assurez-vous d’avoir saisi l’ID de compte et le mot de passe corrects.",
        "Date": "la date",
        "Time": "l’heure",
        "The data will be permanently deleted": "Cette action supprimera définitivement les données actuelles, continuer ou non?",
        "Please select an item to delete first": "Veuillez sélectionner un avant de supprimer",
        "Select an item and then delete":"Sélectionnez un élément, puis supprimez-le",
        "Begin Download": "Démarrer le téléchargement",
        "Start Download":"Lancer le téléchargement",
        "Password incorrect": "Mot de passe incorrect",
        "Password Changed Successfully": "Modifier le mot de passe avec succès",
        "Display ID or Group ID is empty": "Display ID ou Group ID est vide",
        "Select the update package": "Sélectionner le package de mise à jour",
        "Username already exists": "Le nom d'utilisateur existe déjà",
        "Executing monitor setting command。Please wait 10s before making new changes。": "Cette commande de réglage d'affichage est en cours d'exécution, attendez 10S avant de faire un nouveau réglage",
        "Close": "Inactif",
        "Role does not exist。 Cannot modify role。": "Le rôle n'existe pas et ne peut pas être modifié",
        "Unknown Command": "Commande inconnue",
        "Access Token Expired": "Le jeton d'accès a expiré",
        "Invalid Refresh Token": "Jeton de rafraîchissement invalide",
        "Missing Request Parameters:": "Paramètre de demande manquant:",
        "Incorrect Request Parameter Type:": "Requête paramètre type erreur:",
        "Request URL Not Found:": "L'adresse demandée n'existe pas:",
        "Incorrect Request Method:": "Méthode de demande incorrecte:",
        "Log In": "Se connecter",
        "account ID": "Numéro de compte",
        "password": "Mot de passe",
        "Update failed": "Échec de la mise à jour",
        "Reset Password?": "Réinitialiser le mot de passe",
        "Logged in successfully": "Connexion réussie",
        "Please contact the system administrator to reset your password": "Contactez l’administrateur système pour réinitialiser votre mot de passe.",
        "Retry limit exceeded。 Please try again after 30 minutes": "Réessayez plus de 5 fois, Veuillez réessayer dans 30 minutes",
        "Enter the model / host name / firmware version number": "Saisir le modèle / nom d’hôte / numéro de version du micrologiciel",
        "New Group": "Nouveau groupe",
        "Delete Group": "Supprimer un groupe",
        "Display Columns": "Afficher les colonnes",
        "Collapse": "Réduire",
        "Expand": "Développer",
        "Move To": "Déplacer vers",
        "Export": "导出",
        "Power On": "Mettre sous tension",
        "Power Off": "Mettre hors tension",
        "Screen lock": "Verrouillage de l'écran",
        "Unlock screen": "Déverrouillage de l'écran",
        "Settings": "Paramètres",
        "Export Settings Profiles": "Exporter les profils de paramètres",
        "Update": "Mettre à jour",
        "Delete Monitor": "Supprimer le moniteur",
        "Total devices": "Nombre total d’appareils",
        "Selected devices": "Appareils sélectionnés",
        "Update package name": "Nom du package de mise à jour",
        "Update Time": "Heure de mise à jour",
        "Apply to all displays of the same model": "Application au même modèle d'affichage",
        "Display Settings": "Paramètres d’affichage",
        "Select All": "Tout sélectionner",
        "Settings Profiles": "Profils de paramètres",
        "Filename": "Nom de fichier",
        "Group": "Grouper",
        "Monitor Model": "Modèle de moniteur",
        "Special ID": "ID spécial",
        "Host Name": "Nom d’hôte",
        "Host Status": "État de l’hôte",
        "Monitor Status": "État du moniteur",
        "Lock Status": "锁定状态",
        "Update Progress": "Avancement de la mise à jour",
        "Settings Profile": "Profil de configuration",
        "Tips": "Conseils",
        "Active Time": "Temps d’activité",
        "Overclock": "Overclocking",
        "Operation successful": "Opération réussie",
        "Please save data": "Enregistrer les données",
        "Select the data first": "Sélectionner d’abord les données",
        "Cannot modify when ungrouped": "Impossible de modifier si non groupé",
        "Deselect All": "Tout désélectionner",
        "Select the GAMMA node label value": "Sélectionner la valeur de l’étiquette du nœud GAMMA",
        "Ungrouped": "Non groupé",
        "Offline": "Hors ligne",
        "Online": "En ligne",
        "Power on": "Démarrez la machine",
        "Power off": "Arrêt",
        "Locked": "Verrouillé",
        "Open": "Non verrouillé",
        "Open": "Déverrouillé",
        "Unlocked":"Déverrouillé",
        "Not connected": "Non connecté",
        "Connected": "Connexion",
        "Set the update start time": "Définir l’heure de début de la mise à jour",
        "Now": "Maintenant",
        "Set upgrade mode": "设置升级模式",
        "Interactive Mode": "Mode interactif",
        "Silent mode": "Mode silencieux",
        "In this mode， a monitor firmware update screen will appear and request users confirmation to proceed! Users may choose to postpone the update twice, after which the update will be enforced": "Dans ce mode, un écran de mise à jour du microprogramme du moniteur s’affiche et demande aux utilisateurs de confirmer la suite. Les utilisateurs peuvent choisir de reporter la mise à jour deux fois, après quoi la mise à jour sera appliquée.",
        "In this mode， when the monitor is online， the firmware update will be automatically performed in the background。 Users will not see any notifications。 The update will take effect when the display is restarted。 The restart of the monitor takes about a few seconds， and won’t affect any ongoing tasks on your computer。": "Dans ce mode, lorsque le moniteur est en ligne, la mise à jour du micrologiciel est automatiquement effectuée en arrière-plan. Les utilisateurs ne verront aucune notification. La mise à jour prendra effet au redémarrage de l’affichage. Le redémarrage du moniteur prendra quelques secondes et n’affectera pas les tâches en cours sur votre ordinateur.",
        "Invalid input": "Entrée non valide",
        "Failed to log in": "Échec de la connexion",
        "Select your preferred restart time。": "Sélectionnez l’heure de redémarrage de votre choix en fonction de votre utilisation.",
        "You have still selected the group that the device currently belongs to。 If you want to move the device， please select another group。": "您点击的仍是设备现属组，若要移动，请选其他组。",
        "Enter the group name": "Saisir le nom du groupe",
        "Apply profile:": "Appliquer le profil :",
        "A new version is available": "Une nouvelle version est disponible",
        "Restart monitor immediately after update": "Redémarrer le moniteur immédiatement après la mise à jour",
        "Restart when the monitor enters sleep mode": "Redémarrer lorsque le moniteur entre en mode veille",
        "Restart monitor when it disconnected from all PCs": "Redémarrage lorsque le moniteur est déconnecté et que tous les PC sont connectés",
        "Enter the model name": "Saisir le nom du modèle",
        "Create Update Task": "Créer une tâche de mise à jour",
        "Update Task List": "Mettre à jour la liste des tâches",
        "Cancel All": "Annuler tout",
        "View Details": "Afficher les détails",
        "Update Details": "Détails de la mise à jour",
        "Update Mode": "Mode de mise à jour",
        "Update Creation Time": "Heure de création de la mise à jour",
        "Update Start Time": "Heure de début de la mise à jour",
        "Are you sure you want to cancel all tasks?": "Voulez-vous vraiment annuler toutes les tâches ?",
        "Are you sure you want to cancel this task?": "Voulez-vous vraiment annuler cette tâche ?",
        "Are you sure you want to delete the selected monitor?": "Voulez-vous vraiment supprimer le moniteur sélectionné ?",
        "Confirm to delete all displays?": "Confirmer voulez - vous supprimer tous les moniteurs?",
        "Are you sure you want to delete this？（Cannot delete when ungrouped）": "Voulez-vous vraiment supprimer ? (Suppression impossible non groupé)",
        "Tip: If an option in the display settings appears grayed out， it may be restricted by another setting。 Try adjusting other settings to remove the restriction。": "Conseil : Si une option des paramètres d’affichage apparaît grisée, il se peut qu’elle soit limitée par un autre paramètre. Essayez d’ajuster d’autres paramètres pour supprimer la restriction.",
        "The WebSocket connection has been restored": "La connexion WebSocket a été rétablie.",
        "The previous setting is currently being applied。 Please wait until the value changes before making any new settings。": "上一设置正在执行中，请等待数值变化后，再进行新的设置",
        "Please copy this password into the input box: ": "Copier ce mot de passe dans la zone de saisie: ",
        "Ebook": "Livre électronique",
        "largest": "le plus grand",
        "Max":'Max',
        "Turn off auto mode": "Désactiver le mode automatique",
        "Minimum": "Minimum",
        "Restore Factory Settings": "Restaurer les paramètres d’usine",
        "Scenario Mode": "Mode scénario",
        "Color Gamut & Color Temperature": "Gamme de couleurs et température de couleur",
        "Close PIP, PBP":"Fermé",
        "PIP window":"PIP",
        "PBP window":"PBP",
        "Panel Native": "Afficher l'indigène",
        "Neutral": "Neutre",
        "Neutral(7500K)":"Neutre",
        "Reddish(6500K)":"Chaud",
        "Bluish(9300K)":"Froid",
        "Warm": "Chaud",
        "Cool": "Froid",
        "Low Blue Light": "Faible lumière bleue",
        "Custom 1": "Personnalisé 1",
        "Custom 2": "Personnalisé 2",
        "Custom 3": "Personnalisé 3",
        "BT.709": "BT.709",
        "BT.2020": "BT.2020",
        "Video Signal": "Signal vidéo",
        "Game Mode": "Mode jeu",
        "Off": "Fermer",
        "Game 1": "Jeu 1",
        "Game 2": "Jeu 2",
        "Response Time": "Temps de réponse",
        "Normal": "Normal",
        "Extreme": "Extrême",
        "Level 1": "Niveau 1",
        "Level 2": "Niveau 2",
        "Level 3": "Niveau 3",
        "Level 4": "Niveau 4",
        "Level 5": "Niveau 5",
        "Lan Indicator": "Indicateur LAN",
        "Linked": "Lié",
        "No Link": "Sans Lien",
        "Blinking": "Clignotant",
        "Brightness": "Contraste",
        "Contrast": "Luminosité",
        "Smart Light": "Lumière Intelligente",
        "Volume Control": "Contrôle du volume",
        "USB Select": "Sélection USB",
        "DP Select": "Sélection DP",
        "Aspect Ratio": "Ratio d'aspect",
        "Smart Traffic Light": "Feux tricolores intelligentes",
        "daisy chain": "Connexion en série",
        "Dynamic Contrast": "Contraste du dynamique",
        "Smart Energy": "Énergie intelligente",
        "Smart Audio": "Audio intelligent",
        "Distance Warning": "Avertissement de distance",
        "Ambient Light Detection": "Détection de la lumière ambiante",
        "Enabled Ambient Light Detection": "Activer la détection de la lumière ambiante",
        "enabled":"enabled",
        "disabled":"disabled",
        "Waken on Touch": "Réveil Tactile",
        "True Split": "Véritable division",
        "Face Tracking": "Suivi Facial",
        "Audio Smart Switch": "Interrupteur Intelligent Audio",
        "Auto-alarm": "Alarme automatique",
        "KVM Switch": "Interrupteur KVM",
        "KVM切换": "Interrupteur KVM",
        "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor， keyboard and mouse, Enable switching video， keyboard and mouse simultaneously。 If disabled， only switch keyboard and mouse。": "L'interrupteur KVM(Clavier, Vidéo, Souris) permet à deux PC d'utiliser un ensemble de moniteur, clavier et souris, Activez simultanément la commutation de la vidéo, du clavier et de la souris. En cas de désactivation, ne changez que le clavier et la souris",
        "Sitting Reminder": "Rappel de session",
        "Gaming": "Jeux",
        "RGB Gain": "Réglage des couleurs",
        "Serial No": "N° de série",
        "Firmware Version": "Version du microprogramme",
        "Select response time level": "Sélectionner le niveau de temps de réponse",
        "Enable daisy chain": "Activer la connexion en série",
        "Smart Traffic Light is a do not disturb light, helping to reduce distraction": "Feu tricolore intelligente consiste à ne pas déranger la lumière, aidant à réduire la distraction",
        "Enable/Disable the Audio Smart function": "Activer/Désactiver la fonction intelligente Audio",
        "Auto-alarm indicates whether the camera/MIC on monitor is in use": "L'alarme automatique indique si la caméra/MIC dans le moniteur est en train de l'utilisation",
        "Enable Distance Warning": "Activer l’avertissement de distance",
        "Enable/disable face tracking": "Activer/Désactiver le suivi facial",
        "Enable Sitting Reminder": "Activer le rappel de session",
        "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity": "La technologie Audio intelligent vous permet de vous concentrer sur le son devant vous pour améliorer la clarté vocale",
        "Smart Energy technology automatically manages energy consumption by human detection sensor": "La technologie Énergie intelligente gère automatiquement la consommation d'énergie par capteur de détection humaine",
        "Implement PBP through only one cable": "Implémentez PBP à travers uniquement un câble",
        "Enable/Disable vPro technology in the monitor": "Activer/Désactiver la technologie vPro dans le moniteur",
        "Wake system by touch": "Réveil tactile du système",
        "Set video source and USB source (used by keyboard and mouse) for every PC": "Définir la source vidéo et la source USB (utilisée par le clavier et la souris) pour chaque PC",
        "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse": "eKVM vous fournit l'accès instantané pour deux sources PC en appuyant sur les 2 boutons sur votre souris",
        "Enable USB charging always on": "Activer la charge USB toujours allumée",
        "Select DP version": "Choisissez la version de DP",
        "USB Charging": "Charge USB",
        "PC": "PC",
        "Double-click the CTRL": "Double-cliquez sur le CTRL",
        "Full Screen": "Plein écran",
        "Original AR": "AR original",
        "No scaling": "Aucune mise à l’échelle",
        "on": "Ouvrir",
        "On": "Ouvrir",
        "Keyboard On": "Clavier Activé",
        "Mouse On": "Souris Activée",
        "Image Creation": "Création d'image",
        "Digital Cinema": "Cinéma numérique",
        "Video Creation": "Création vidéo",
        "Web Browsing": "Navigation web",
        "Professional Image": "Image Professionnelle",
        "DisplayPort": "DisplayPort",
        "Auto": "Auto",
        "Refresh": "Rafraîchir",
        "Search": "Rechercher",
        "Record": "Enregistrement",
        "Username": "Nom d’utilisateur",
        "Upload Time": "Temps de chargement",
        "Add Profiles": "Ajouter des profils",
        "Latest Update Package": "Dernier package de mise à jour",
        "Upload Update Package": "Charger le package de mise à jour",
        "Upload": "Charger",
        "Size": "Taille",
        "Upload successful": "Chargement réussi",
        "Download successful": "Téléchargement réussi",
        "Refresh successful": "Actualisation réussie",
        "The upgrade package does not match the device model": "Le package de mise à niveau ne correspond pas au modèle",
        "Upgrade package does not match the device model":"Le package de mise à niveau ne correspond pas au modèle du périphérique",
        "Please enter the setting name": "Veuillez entrer un nom de réglage",
        "Edit": "Modifier",
        "Save": "Enregistrer",
        "Delete": "Supprimer",
        "Add": "Ajouter",
        "Reset Password": "Réinitialiser le mot de passe",
        "No": "N°.",
        "Full Name": "Nom complet",
        "Role": "Rôle",
        "Creation Date": "Date de création",
        "Operation": "Opération",
        "Actions": "Opération",
        "The user's initial password is ": "该用户的初始密码为 ",
        "The password has been reset to：": "Le mot de passe a été réinitialisé comme suit: ",
        "Invalid input。Usernames can only contain numbers and letters。": "Entrée non valide. Le nom d’utilisateur est composé de chiffres et de lettres.",
        "Invalid input。The username must contain 4 to 30 characters。": "Entrée non valide. Le nom d’utilisateur doit contenir de 4 à 30 caractères.",
        "Installation Package": "Package d’installation",
        "Operation Date": "Date de l’opération",
        "Actions": "Actions",
        "Operator": "Opérateur",
        "Paging component": "Component de pagination",
        "Quick page flipping": "Flipper de page rapide",
        "Current page": "Page actuelle",
        "Title": "Titre",
        "Details": "Détails",
        "This is the expanded area": "This is the expanded area",
        "Set Display Column": "Définir la colonne d'affichage",
        "Upload file": "Télécharger un fichier",
        "Drop-down to expand": "Drop-down pour élargir",
        "Default": "Par défaut",
        "Default Info": "Informations par défaut",
        "Personal Center": "Centre personnel",
        "Personal center image button": "Bouton d'image du centre personnel",
        "Expandable area": "Zone extensible",
        "Update Package Table": "Update Package Table",
        "This is the table header": "C'est l'en-tête de table",
        "This is the table content": "Ceci est le contenu de la table",
        "UserList Table": "Table de la liste des utilisateurs",
        "Page Up and Down": "Page haut et bas",
        "Operation record table": "Operation record table",
        "OSD upgrade details": "Détails de mise à niveau OSD",
        "Lenovo": "Lenovo",
        "Display Fleet Manager": "Display Fleet Manager",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gama": "Gama",
        "PIP/PBP": "PIP/PBP",
        "OSD": "OSD",
        "USB-C Charging": "Recharge USB-C",
        "PIP": "PIP",
        "PBP": "PBP",
        /*
        "Simplified Chinese": "Chinois simplifié",
        "English": "Anglais",
        "Traditional Chinese": "Chinois traditionnel",
        "French": "Français",
        "German": "Allemand",
        "Italian": "Italien",
        "Spanish": "Espagnol",
        "Japanese": "Japonais",
        "Thai": "Thaï",
        "Ukrainian": "Ukrainien",
        "Russian": "Russe",
        */
        "Enter your account ID": "Saisir votre ID de compte",
        "Please Enter your account id":"Contactez l’administrateur système pour réinitialiser votre mot de passe.",
        "Enter your password": "Saisir votre mot de passe",
        "Cannot exceed 20 characters": "Ne doit pas dépasser 20 caractères",
        "Enter the original password": "Saisir le mot de passe d’origine",
        "You have still selected the group that the device currently belongs to。 If you want to move the device, please select another group。": "Vous avez encore sélectionné le groupe auquel l’appareil appartient. Si vous souhaitez déplacer l’appareil, sélectionnez un autre groupe. ",
        "Enter the filename": "Saisir le nom du fichier",
        "Update Package Name": "Nom du package de mise à jour",
        "Select the date": "Sélectionner la date",
        "Select the time": "Sélectionner l’heure",
        "Set the update mode": "Définir le mode de mise à jour",
        "Restart when the monitor is not connected to any computer": "Redémarrer lorsque le moniteur n’est branché à aucun ordinateur",
        "Invalid file format": "Format de fichier non valide. Seuls les fichiers zip/exe/dmg/app sont pris en charge.",
        "Select a valid file type": "Sélectionner un type de fichier valide",

        "The data is being processed。 Please do not submit again。": "Les données sont en cours de traitement. Ne soumettez pas à nouveau.",
        "Enter the profiles name": "Saisir le nom du profil",
        "Enter your username": "Saisir votre nom d’utilisateur",
        "Enter your full name": "Saisir votre nom complet",
        "The initial password of this user is:": "Le mot de passe initial de cet utilisateur est: ",
        "Select your role": "Sélectionner votre rôle",
        "User Profile": "Profil de l’utilisateur",
        "Downloading": "Téléchargement en cours...",
        "Enter the new password again。Two times of new password input is same": "Saisissez à nouveau le nouveau mot de passe.Le nouveau mot de passe doit correspondre à la saisie précédente.",
        "Request failed with status code 502": "La demande a échoué avec le code d'état 502",
        "Please Enter your x": "Saisir {param}",
        "Select the x": "Sélectionner {param}",
        "Please select the correct file type x": "Sélectionner un type de fichier valide{param}",
        "Please select the correct file type": "Sélectionner un type de fichier valide",
        "Input characters within x characters": "Caractères d'entrée à moins de {param} caractères",

        "Monitor List":"Liste de moniteurs",
        "List of update packages":"Liste des mises à jour",
        "Settings - Profiles":"Paramètres - Profils",
        "User Management":"Gestion des utilisateurs",
    

        "Simplified Chinese": "简体中文",
        "English": "English",
        "Traditional Chinese": "繁體中文",
        "French": "Français",
        "German": "Deutsch",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "日本語",
        "Thai": "ภาษาไทย",
        "Ukrainian": "Українська",
        "Russian": "Русский язык",

        "System abnormality":"Anomalies du système",

        "Upgrade Package Record ID is empty":"Sélectionner le package de mise à jour",
        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。":"Heure de mise à jour invalide. Il ne peut être plus tôt que l'heure actuelle ou plus de 30 jours à l'avenir.",

        "Request parameter is invalid:The username must contain 4 to 30 characters。":"Le paramètre de demande n'est pas valide :Le nom d'utilisateur doit contenir de 4 à 30 caractères.",
        "The WebSocket connection has been lost Reconnecting":"La connexion WebSocket a été perdue",
        "Request parameter is invalid：Usernames can only contain numbers and letters。":"Le paramètre de demande est invalide:Le nom d'utilisateur se compose de chiffres et de lettres.",

        "Request parameter is invalid:Password length must be between 8-16 character":"Le paramètre de demande n'est pas valide:La longueur du mot de passe doit être comprise entre 8 et 16 caractères",
        "The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling":"Le paquet compilé est manquant : le composant a une corbeille correspondante qui n'a pas été téléchargée. Veuillez le télécharger avant de compiler.",

        "Request parameter is invalid：Password length must be 8–16 characters":"Le paramètre de demande n'est pas valide:La longueur du mot de passe doit être comprise entre 8 et 16 caractères",


        "Illegal request header!": "En-tête de requête illégal!",
        "Invalid request parameters":"Paramètres de demande invalides",
        "Export": "Exporter",
        "It is already a high-version and there is no need to upgrade":"It is already a high-version and there is no need to upgrade",
        "Repeated request， please try again later":"Repeated request, please try again later",
        "Communication":"Communication"
    }
}